import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL;

export interface SuggestionRequest {
  currentText: string;
  context: {
    nomineeNames?: string | string[];
    selectedValue?: string;
    awardType?: string;
    contributionTowards?: string[];
    businessOutcome?: string;
    isTeamAward?: boolean;
  };
  maxSuggestions?: number;
}

const toPayload = (request: SuggestionRequest) => ({
  currentText: request.currentText,
  context: {
    ...request.context,
    nomineeNames: Array.isArray(request.context.nomineeNames)
      ? request.context.nomineeNames.join(', ')
      : request.context.nomineeNames,
  },
  maxSuggestions: request.maxSuggestions,
});

export const getWritingSuggestion = async (
  request: SuggestionRequest,
  token: string
): Promise<string> => {
  try {
    const response = await axios.post(
      `${BASE}/api/AI/get-suggestion`,
      toPayload(request),
      {
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        timeout: 10000,
      }
    );
    return response.data.suggestion || '';
  } catch (error: any) {
    console.debug('AI suggestion error:', error?.response?.status, error?.message);
    return '';
  }
};

export const getSuggestionOptions = async (
  request: SuggestionRequest,
  token: string
): Promise<string[]> => {
  try {
    const response = await axios.post(
      `${BASE}/api/AI/get-suggestions`,
      toPayload({ ...request, maxSuggestions: request.maxSuggestions ?? 3 }),
      {
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        timeout: 10000,
      }
    );
    return response.data.suggestions || [];
  } catch (error: any) {
    console.debug('AI suggestions error:', error?.response?.status, error?.message);
    return [];
  }
};
